import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { globalConfig, LocaleKey, ThemeKey } from '../config/config';
import { changeTheme } from '../redux/theme/themeSlice';
import { changeLocale } from '../redux/intl/intlSlice';
import i18n from '../i18n';

const availableChangeKeys = [ThemeKey, LocaleKey]

export const useConfigListener = () => {
    const dispatch = useDispatch();
    
    useEffect(() => {
        // 纯React版本：监听localStorage变化
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'mindplus-config' && e.newValue) {
                try {
                    const config = JSON.parse(e.newValue);
                    globalConfig._config = config;
                    availableChangeKeys.forEach(key => {
                        if (config[key]) {
                            if (key === ThemeKey) {
                                dispatch(changeTheme(config[key]));
                            }
                            if (key === LocaleKey) {
                                dispatch(changeLocale(config[key]));  // 保持用户选择的值
                                // 同步更新i18n语言设置，只在i18n切换时做映射
                                if (i18n.isInitialized) {
                                    // 简体中文和繁體中文都使用 zh-CN，其他语言都使用 en
                                    let i18nLocal = (config[key] === "zh-cn" || config[key] === "zh-tw") ? "zh-CN" : "en";
                                    i18n.changeLanguage(i18nLocal);
                                }
                            }
                        }
                    });
                } catch (error) {
                    console.log("useConfigListener error", error);
                }
            }
        };

        // 监听storage事件
        window.addEventListener('storage', handleStorageChange);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [dispatch]);
}
